import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { ServicecallService } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class PopOverTemplatesService {
  vehicleStateConfig: any = {};

  constructor(private _sharedService: ServicecallService, private _datePipe: DatePipe) {
  }

  getVehiclePopOverTemplate(markerItem: any) {
    const trackerTemplate =
      '<div>' +
      '<div class="pop-header-tracker d-flex">' +
      '<div class="d-flex w-100">' +
      '<div class="mr-4 d-flex align-items-center">' +
      '<div class="d-flex"><img src="../../../../assets/images/bellIcon.svg" title="Alerts" class="h-30 space-after-icon"' +
      'alt="Alerts"><a style="display:flex;" href="/#/events/alerts/' + markerItem.entityId + '"><strong class="ft-20">' + markerItem.totalAlertCount + '</strong></a>' +
      '</div>' +
      '</div><a href="/#/' + markerItem.entityModule + '/profile/' + markerItem.entityId + '" class="go-to-profile-btn ml-auto ripple">' +
      '<img src="../../../../assets/images/go-profile.svg" title="Go to profile" class="space-after-icon"' +
      'alt="go to profile"></a>' +
      '</div>' +
      '</div>' +
      '<div class="d-flex grid-column padt-5">' +
      '<div class="d-flex align-items-center mx-3 tracker-popover mw-100 tracker-pop-border-right padb-5">' +
      '<div  class="d-flex">' +
      '<div class="position-relative l-space-between-containers"><img alt="User"' +
      'class="card-img-top rounded-circle image-container ng-star-inserted"' +
      'src="' + markerItem['image'] + '">' +
      '</div>' +
      '</div>' +
      '<div>' +
      '<a href="/#/' + markerItem.entityModule + '/profile/' + markerItem.entityId + '">' +
      '<span class="center"><strong>' + markerItem.entityName + '</strong></span></a>' +
      '</div>' +
      '<div class="padt-5 text-center">' +
      '<span class="center" style="color:#58c67b">' + markerItem.time + '</span>' +
      '</div>' +
      '<div class="d-flex align-items-center mx-3" style="padding-top:20px;"><br><span class="center">' + '97' + '<img src="../../../../assets/images/star-solid.svg"' +
      'class="w-20 star" title="Vehicle Score" alt="Vehicle Score"></span></div>' +
      '</div>' +
      '<div class="att-overflow w-100">' + markerItem['attributeHtml'] +
      '</div>' +
      '</div>' +
      '</div>';
    return trackerTemplate;
  }

  getVehicleValidopsPopover(markerItem: any) {
    const stateDate = this._sharedService.getDateState('tracker') ? this._sharedService.getDateState('tracker')?.date : this._sharedService.getDateState('global')?.date;
    const startDate = encodeURIComponent(this._datePipe.transform(stateDate?.startDate, 'yyyy-MM-ddTHH:mm:ssZZ'));
    const trackerRange = this._sharedService.getDateState('tracker')?.range ?? this._sharedService.getDateState('global')?.range;
    const endDate = encodeURIComponent(this._datePipe.transform(( trackerRange === 'Yesterday' || trackerRange === 'Custom') ? new Date(stateDate.endDate) : new Date(), 'yyyy-MM-ddTHH:mm:ssZZ'));
    this.vehicleStateConfig = this._sharedService.getConfiguration('tenantGenericConfig')?.trackerVehicleStateWidgets
      ? this._sharedService.getConfiguration('tenantGenericConfig')?.trackerVehicleStateWidgets
      : null;

    // Get state details
    const stateDetails = this.vehicleStateConfig?.find((item: any) => item?.state === markerItem?.['attribute.derived.vehicleState']);

    // Get colors
    const bgColor = stateDetails?.selectedBgColor || '#ccc'; // Default gray background
    const textColor = stateDetails?.textColor || '#000'; // Default black text
    const vehicleStateTitle = stateDetails?.name;


    const trackerTemplate =
   '<div class="mat-mdc-card-content tracker-pop-over">' +
  '<div>' +
    '<div class="d-grid grid-column-validops align-items-center">' +
      '<div class="d-grid grid-column">' +
        '<div class="d-flex flex-column justify-content-center w-100">' +
          '<div class="d-flex ai-center">' +
            '<a href="/#/' + markerItem.entityModule + '/profile/' + markerItem.entityId + '?fromDate=' + startDate +
                '&toDate=' + endDate + '&stateRange=' + trackerRange + '">' +
              '<span class="center"><strong style="padding-right: 5px;">' + markerItem.entityName + '</strong></span>' +
            '</a>' +
            (vehicleStateTitle
              ? `<div class="validops-chips" style="background-color: ${bgColor}; color: ${textColor};">
                  ${vehicleStateTitle}
                 </div>`
              : '') +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +
'<div class="split-container">' +
'<div class="leaflet-popup-left">' +
  '<div class="d-grid grid-column gp-20 ">' +
    '<div class="d-flex flex-column justify-content-center align-items-start w-100 list-of-vehicle">' +
      '<div class="position-relative mt-3">' +
        '<img alt="User"' +
        ' class="card-img-top rounded-circle image-container ng-star-inserted"' +
        ' src="' + (markerItem['image'] ?? markerItem['markerImg']) + '">' +
      '</div>' +
    '</div>' +

    '<div class="d-flex flex-column justify-content-center w-100 mt-3">' +
      '<div>' +
        '<div class="tile-data-cp">' +
          '<div class="d-flex gap-2">' +
            `<div class="validops-chips">${markerItem?.entityCategory ?? '-'}</div>` +
            `<div class="validops-chips">${markerItem?.type ?? '-'}</div>` +
          '</div>' +
          `<div class="details-font-validops uni-details-font">${markerItem?.name ?? '-'} / ${markerItem?.make ?? '-'}</div>` +
          `<div class="details-font-validops uni-details-font">${markerItem?.model ?? '-'}</div>` +

          '<div class="details-sub-font-validops uni-details-sub-font">' +
            '<div>' +
              '<img src="../../../../assets/images/validops-fueltype.svg" alt="Fuel Type" />' + markerItem?.fuelType +
            '</div>' +
            '<div>' +
              `<img src="../../../../assets/images/validops-location.svg" alt="Location" />${markerItem?.mapLocation}` +
              `<div>(${markerItem?.time})</div>` +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

    '<div class="d-flex align-items-end mb-3">' +
      '<div class="d-flex align-items-basline w-100 gap10 enity-summary">' +
        '<div class="validops-footer uni-profile-footer">' +
          '<div class="validops-value uni-profile-value">' +
            (markerItem?.aggrDetails?.totalDistance ? markerItem?.aggrDetails?.trimmedTotalDistance : 0) + ' Km' +
          '</div>' +
          '<div class="validops-value-footer uni-profile-value-footer d-flex">' +
            '<div><img src="../../../../assets/images/distancevalidops.svg" alt="Distance" matTooltip="Distance"></div>' +
            '<div class="uni-profile-value-label-footer">Distance</div>' +
          '</div>' +
        '</div>' +

        '<div class="validops-footer uni-profile-footer">' +
          '<div class="validops-value uni-profile-value">' +
            (markerItem?.aggrDetails?.totalEnginehours ? markerItem?.aggrDetails?.totalEnginehoursTrimmed : 0) + ' hrs' +
          '</div>' +
          '<div class="validops-value-footer uni-profile-value-footer d-flex">' +
            '<div><img src="../../../../assets/images/enginehrs.svg" alt="Engine" matTooltip="Engine"></div>' +
            '<div class="uni-profile-value-label-footer">' +
              (markerItem?.fuelType === 'EV' ? 'Battery' : 'Engine') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +
  '<div class="leaflet-popup-right">' +
    '<div class="d-flex padt-5 justify-space-between popup-right">' +
      '<div>' + // Segment
        '<div>' +
          '<div class="details-sub-font-validops uni-details-sub-font">Segment</div>' +
          '<div>' + markerItem?.entityCategory + '</div>' +
        '</div>' +
        '<div>' +
          '<div class="details-sub-font-validops uni-details-sub-font">STR</div>' +
          '<a href="/#/' + markerItem.entityModule + '/profile/' + markerItem.entityId + '?fromDate=' + startDate +
                '&toDate=' + endDate + '&stateRange=' + trackerRange + '">' +
            '<span>' + markerItem.name + '</span>' +
          '</a>' +
        '</div>' +
      '</div>' +

      '<div>' + // DTC Case + Rule Case + Alerts
        '<div>' +
          '<div class="details-sub-font-validops uni-details-sub-font">DTC Case</div>' +
          '<div>' +
            (markerItem.dtcCase
              ? '<a href="/#/dtc/dtcList?fromDate=' + startDate +
                '&toDate=' + endDate + '&stateRange=' + trackerRange + '"><span>' +
                markerItem.dtcCase + '</span></a>'
              : '<span>-</span>'
            ) +
        '</div>' +
        '</div>' +
        '<div>' +
          '<div class="details-sub-font-validops uni-details-sub-font">Rule Case</div>' +
          '<div>-</div>' +
        '</div>' +
        '<div>' +
          '<div class="details-sub-font-validops uni-details-sub-font">Active Alerts</div>' +
          '<div>' +
            (markerItem.totalAlertCount !== "" && markerItem.totalAlertCount !== undefined
              ? `<a style="display:flex;" href="/#/events/alerts/${markerItem.entityId}?fromDate=${startDate}&toDate=${endDate}&stateRange=${trackerRange}">${markerItem.totalAlertCount ?? '-'}</a>`
              : '<span>-</span>') +
          '</div>' +
        '</div>' +
      '</div>' +
  '</div>'+
  '</div>'+
  '</div>';
    // return trackerTemplate;
  const tempConfig = this._sharedService.getConfiguration('tenantGenericConfig')?.tempConfig ? 
  this._sharedService.getConfiguration('tenantGenericConfig')?.tempConfig :null;
  return  tempConfig ? this.getTelecomPopoverTemplate(markerItem, tempConfig): trackerTemplate;
  }

  getSitesPopOverTemplate(markerItem: any) {
    const sitePopOverTemplate =
      '<div class="d-grid form-gap w-100 grid-column"><div class="d-flex"><img src="../../../../assets/images/bellIcon.svg" style="pointer-events:none;"' +
      'title="Alerts" class="h-30 space-after-icon" alt="Alerts">' +
      '<a style="display:flex;" href="/#/events/alerts/' + markerItem.entityId + '"><strong class="ft-20">' + markerItem.totalAlertCount +
      '</strong></a></div><div class="d-flex align-items-center" style="color:red">' + markerItem['alertName'] + '</div><a style="padding:0;" class="nav-link go-to-profile-btn ml-auto ripple" href="/#/plants/profile/' + markerItem.entityId + '">' +
      '<img src="../../../../assets/images/go-profile.svg" title="Go to profile" class="h-30 space-after-icon" alt="goto"></a></div>' +
      '<div class="d-grid grid-column"><div class="d-flex flex-column justify-content-center align-items-center w-100 l-space-between-containers">' +
      '<div class="position-relative l-space-between-containers"><img src="' + markerItem['image'] + '"' +
      'class="card-img-top rounded-circle image-container" alt="vehicle"></div>' +
      '</div><div style="padding: 15px;"><div class="d-flex flex-column justify-content-center w-100"><div class="d-flex"></div>' +
      '<h5 class="l-space-between-containers"><a style="display:flex;" class="site" href="/#/tracker?id=' + markerItem.entityId + '">' + '<strong>' + markerItem['entityName'] + '</strong></a>' +
      '</h5></div></div></div>';
    return sitePopOverTemplate;
  }

  getOtherEntityPopOverTemplate(markerItem: any) {
    const otherEntityPopOverTemplate =
      '<div>' +
      '<div class="pop-header-tracker d-flex">' +
      '<div class="d-flex w-100">' +
      '<div class="mr-4 d-flex align-items-center">' +
      '<div class="d-flex"><img src="../../../../assets/images/bellIcon.svg" title="Alerts" class="h-30 space-after-icon"' +
      'alt="Alerts"><a style="display:flex;" href="/#/events/alerts/' + markerItem.entityId + '"><strong class="ft-20">' + markerItem.totalAlertCount + '</strong></a>' +
      '</div>' +
      '</div><a href="/#/' + markerItem.entityModule + '/profile/' + markerItem.entityId + '" class="go-to-profile-btn ml-auto ripple">' +
      '<img src="../../../../assets/images/go-profile.svg" title="Go to profile" class="space-after-icon"' +
      'alt="go to profile"></a>' +
      '</div>' +
      '</div>' +
      '<div class="d-flex grid-column padt-5">' +
      '<div class="d-flex align-items-center mx-3 tracker-popover mw-100 tracker-pop-border-right padb-5">' +
      '<div  class="d-flex">' +
      '<div class="position-relative l-space-between-containers"><img alt="User"' +
      'class="card-img-top rounded-circle image-container ng-star-inserted"' +
      'src="' + markerItem['image'] + '">' +
      '</div>' +
      '</div>' +
      '<div>' +
      '<a href="/#/' + markerItem.entityModule + '/profile/' + markerItem.entityId + '">' +
      '<span class="center"><strong>' + markerItem.entityName + '</strong></span></a>' +
      '</div>' +
      '<div class="padt-5 text-center">' +
      '<span class="center" style="color:#58c67b">' + markerItem.time + '</span>' +
      '</div>' +
      '</div>' +
      '<div class="att-overflow w-100">' + markerItem['attributeHtml'] +
      '</div>' +
      '</div>' +
      '</div>';
    return otherEntityPopOverTemplate;
  }

  checkVehicleCategory(category: string) {
    const vehicleCategoryList = [
      'passengerFleet',
      'sharedMobility',
      'trucking',
      'lastMileLogistics'
    ];
    return vehicleCategoryList.includes(category);
  }

  // to be deleted
  getTelecomPopoverTemplate(markerItem: any, tempConfig: any) {
      const telecomPopover =
   '<div class="mat-mdc-card-content tracker-pop-over">' +
  '<div>' +
    '<div class="d-grid grid-column-validops align-items-center">' +
      '<div class="d-grid grid-column">' +
        '<div class="d-flex flex-column justify-content-center w-100">' +
          '<div class="d-flex ai-center">' +
            '<a href="'+tempConfig?.trackerDialogRedirectionUrl+'"'+'target="_blank" rel="noopener noreferrer">' +
              '<span class="center"><strong style="padding-right: 5px;">' + markerItem.entityName + '</strong></span>' +
            '</a></div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +
'<div class="split-container">' +
'<div class="leaflet-popup-left">' +
  '<div class="d-grid grid-column gp-20 ">' +
    '<div class="d-flex flex-column justify-content-center align-items-start w-100 list-of-vehicle">' +
      '<div class="position-relative mt-3">' +
        '<img alt="User"' +
        ' class="card-img-top rounded-circle image-container ng-star-inserted"' +
        ' src="' + (markerItem['image'] ?? markerItem['markerImg']) + '">' +
      '</div>' +
    '</div>' +

    '<div class="d-flex flex-column justify-content-center w-100 mt-3">' +
      '<div>' +
        '<div class="tile-data-cp">' +
          // '<div class="d-flex gap-2">' +
          //   `<div class="validops-chips">${markerItem?.entityCategory ?? '-'}</div>` +
          //   `<div class="validops-chips">${markerItem?.type ?? '-'}</div>` +
          // '</div>' +
          `<div class="details-font-validops uni-details-font">${markerItem?.name ?? '-'} / ${markerItem?.make ?? '-'}</div>` +
          `<div class="details-font-validops uni-details-font">${markerItem?.model ?? '-'}</div>` +

          '<div class="details-sub-font-validops uni-details-sub-font">' +
            // '<div>' +
            //   '<img src="../../../../assets/images/validops-fueltype.svg" alt="Fuel Type" />' + markerItem?.fuelType +
            // '</div>' +
            '<div>' +
              `<img src="../../../../assets/images/validops-location.svg" alt="Location" />${markerItem?.mapLocation}` +
              `<div>(${markerItem?.time})</div>` +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>' +
  '</div>' +

    // '<div class="d-flex align-items-end mb-3">' +
    //   '<div class="d-flex align-items-basline w-100 gap10 enity-summary">' +
    //     '<div class="validops-footer uni-profile-footer">' +
    //       '<div class="validops-value uni-profile-value">' +
    //         (markerItem?.aggrDetails?.totalDistance ? markerItem?.aggrDetails?.trimmedTotalDistance : 0) + ' Km' +
    //       '</div>' +
    //       '<div class="validops-value-footer uni-profile-value-footer d-flex">' +
    //         '<div><img src="../../../../assets/images/distancevalidops.svg" alt="Distance" matTooltip="Distance"></div>' +
    //         '<div class="uni-profile-value-label-footer">Distance</div>' +
    //       '</div>' +
    //     '</div>' +

    //     '<div class="validops-footer uni-profile-footer">' +
    //       '<div class="validops-value uni-profile-value">' +
    //         (markerItem?.aggrDetails?.totalEnginehours ? markerItem?.aggrDetails?.totalEnginehoursTrimmed : 0) + ' hrs' +
    //       '</div>' +
    //       '<div class="validops-value-footer uni-profile-value-footer d-flex">' +
    //         '<div><img src="../../../../assets/images/enginehrs.svg" alt="Engine" matTooltip="Engine"></div>' +
    //         '<div class="uni-profile-value-label-footer">' +
    //           (markerItem?.fuelType === 'EV' ? 'Battery' : 'Engine') +
    //         '</div>' +
    //       '</div>' +
    //     '</div>' +
    //   '</div>' +
    // '</div>' +
  // '</div>' +
  // '<div class="leaflet-popup-right">' +
  //   '<div class="d-flex padt-5 justify-space-between popup-right">' +
  //     '<div>' + // Segment
  //       '<div>' +
  //         '<div class="details-sub-font-validops uni-details-sub-font">Segment</div>' +
  //         '<div>' + markerItem?.entityCategory + '</div>' +
  //       '</div>' +
  //       '<div>' +
  //         '<div class="details-sub-font-validops uni-details-sub-font">STR</div>' +
  //         '<a href="/#/' + markerItem.entityModule + '/profile/' + markerItem.entityId + '">' +
  //           '<span>' + markerItem.name + '</span>' +
  //         '</a>' +
  //       '</div>' +
  //     '</div>' +

  //     '<div>' + // DTC Case + Rule Case + Alerts
  //       '<div>' +
  //         '<div class="details-sub-font-validops uni-details-sub-font">DTC Case</div>' +
  //         '<div>' +
  //           (markerItem.dtcCase !== "" && markerItem.dtcCase !== undefined
  //             ? '<a href="/#/dtc/dtcList"><span> ' + markerItem?.dtcCase + ' </span></a>'
  //             : '<span>-</span>') +
  //         '</div>' +
  //       '</div>' +
  //       '<div>' +
  //         '<div class="details-sub-font-validops uni-details-sub-font">Rule Case</div>' +
  //         '<div>-</div>' +
  //       '</div>' +
  //       '<div>' +
  //         '<div class="details-sub-font-validops uni-details-sub-font">Active Alerts</div>' +
  //         '<div>' +
  //           (markerItem.totalAlertCount !== "" && markerItem.totalAlertCount !== undefined
  //             ? `<a style="display:flex;" href="/#/events/alerts/${markerItem.entityId}">${markerItem.totalAlertCount ?? '-'}</a>`
  //             : '<span>-</span>') +
  //         '</div>' +
  //       '</div>' +
  //     '</div>' +
  // '</div>'+
  '</div>'+
  '</div>';
  return telecomPopover
  }
}
